// extracted by mini-css-extract-plugin
export default {"form":"nickname_form__I8z0q","tip":"nickname_tip__vUGMQ","submit":"nickname_submit__Pyvv-","camera":"nickname_camera__7BP0y","camera_content":"nickname_camera_content__9Up9Y"};